/*global MP4Box*/
import '../app.es6';
import angular from 'angular';

class VideoParser {
  /* @ngInject */
  constructor () {
    this.mp4box = '';
    this.videoInfo = '';
  }

  initMP4Box () {
    console.log('init mp4');
    let mp4box = new MP4Box();
    mp4box.onReady = function (info) {
      console.log('###mp4box onReady###');
    };
    mp4box.onError = function (e) {
      console.log('###mp4box failed to parse data.###');
    };
    mp4box.onMoovStart = function (info) {
      console.log('###mp4box onMoovStart###');
    };
    return mp4box;
  }

  setDataToMP4Box (file) {
    this.mp4box = this.initMP4Box();
    return new Promise((resolve, reject) => {
      let fileReader = new FileReader();
      // TODO: クラスのメソッドにしてしまうとthisが変わる
      let onBlockRead = (event) => {
        let buffer = event.target.result;
        buffer.fileStart = 0;
        this.mp4box.appendBuffer(buffer);
        this.mp4box.flush();
        this.videoInfo = this.mp4box.getInfo();
        resolve();
      };
      fileReader.onload = onBlockRead;
      fileReader.readAsArrayBuffer(file);
    });
  }

  getVideoInfo () {
    return this.videoInfo;
  }

  getEndUnixTime () {
    let duration = (this.videoInfo.duration / this.videoInfo.timescale) * 1000;
    let startTime = this.getStartUnixTime() + duration;
    return startTime;
  }

  getStartUnixTime () {
    let ct = this.mp4box.inputIsoFile.moov.boxes[0].creation_time;
    let dt = Date.UTC(1904, 0, 1, 0, 0, 0);
    let creationTime = ct * 1000 + dt;
    return creationTime;
  }

  getResolution () {
    return `${this.videoInfo.videoTracks[0].track_height}p`;
  }
}

angular.module('myApp').service('videoParser', VideoParser);



// WEBPACK FOOTER //
// ./app/services/video-parser.es6